module.exports = __webpack_public_path__ + "static/media/current-amount-icon.2a730f85.svg";